import { Grid, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import TrendlineChart from './TrendlineChart';

const TrendlineView = () => {
  const params = useParams();
  const snapshotId = Number(params.snapshotId);

  return (
    <Grid container component={Paper}>
      <Grid item xs={6}>
        <TrendlineChart snapshotId={snapshotId} interval='Day' />
      </Grid>
      <Grid item xs={6}>
        <TrendlineChart snapshotId={snapshotId} interval='Week' />
      </Grid>
      <Grid item xs={6}>
        <TrendlineChart snapshotId={snapshotId} interval='Month' />
      </Grid>
      <Grid item xs={6}>
        <TrendlineChart snapshotId={snapshotId} interval='Year' />
      </Grid>
    </Grid>
  );
};

export default TrendlineView;
